import Vue from 'vue'
import router from '@/router'
import store from '@/store/'
import { ACCESS_TOKEN, USER_ROLE } from "@/store/mutation-types";
import HomeLayout from './layouts/HomeLayout'
import FullScreenLayout from './layouts/FullScreenLayout'


router.beforeEach((to, from, next) => {
  if (Vue.ls.get(ACCESS_TOKEN)) {
    next()
  } else {
    if (to.meta.auth) {
      // next()
      next({ path: '/login', query: { redirect: to.fullPath } })
    } else {
      next()
    }
  }
})

let tenantConfig = store.getters.tenantInfo

/**
 * 基础路由
 * @type { *[] }
 */
const RouterMap = [
  {
    path: '/',
    component: HomeLayout,
    redirect: tenantConfig && tenantConfig.home || '/index',
    hidden: true,
    children: [
      {
        path: '/index',
        name: 'index',
        component: () => import(/* webpackChunkName: "xjtech" */ './views/Home'),
        meta: { title: '首页', auth: false }
      },

    ]
  },
  {
    path: '/personal',
    component: HomeLayout,
    children: [
      {
        path: '',
        name: 'personalCenter',
        meta: { auth: true, title: '个人中心' },
        component: () => import(/* webpackChunkName: "xjtech" */ './views/PersonalCenter')
      }
    ]
  },
  {
    path: '/achievement',
    component: HomeLayout,
    redirect: '/achievement/list',
    children: [
      {
        path: 'create',
        name: 'achievementCreate',
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "xjtech" */ './views/AchievementCreate')
      },
      {
        path: 'list',
        name: 'achievementList',
        meta: { auth: false },
        component: () => import(/* webpackChunkName: "xjtech" */ './views/AchievementList')
      },
      {
        path: 'detail',
        name: 'achievementDetail',
        meta: { auth: false },
        component: () => import(/* webpackChunkName: "xjtech" */ './views/AchievementDetail')
      }
    ]
  },
  {
    path: '/demand',
    component: HomeLayout,
    redirect: '/demand/list',
    children: [
      {
        path: 'create',
        name: 'demandCreate',
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "xjtech" */ './views/DemandCreate')
      },
      {
        path: 'list',
        name: 'demandtList',
        meta: { auth: false },
        component: () => import(/* webpackChunkName: "xjtech" */ './views/DemandList')
      },
      {
        path: 'detail',
        name: 'detail',
        meta: { auth: false },
        component: () => import(/* webpackChunkName: "xjtech" */ './views/DemandDetail')
      },
    ]
  },
  {
    path: '/event',
    component: HomeLayout,
    redirect: '/event/list',
    children: [
      {
        path: 'list',
        name: 'eventList',
        meta: { auth: false },
        component: () => import(/* webpackChunkName: "xjtech" */ './views/EventList')
      },
      {
        path: 'detail',
        name: 'eventDetail',
        meta: { auth: false },
        component: () => import(/* webpackChunkName: "xjtech" */ './views/EventDetail')
      },
      {
        path: 'signup',
        name: 'eventSignup',
        meta: { auth: true },
        component: () => import(/* webpackChunkName: "xjtech" */ './views/EventSignup')
      }
    ]
  },
  {
    path: '/cms',
    component: HomeLayout,
    redirect: '/cms/list',
    children: [
      {
        path: 'index',
        name: 'cmsIndex',
        meta: { auth: false },
        component: () => import(/* webpackChunkName: "xjtech" */ './views/CmsListAuto')
      },
      {
        path: 'list',
        name: 'list',
        meta: { auth: false },
        component: () => import(/* webpackChunkName: "xjtech" */ './views/cms/CmsList')
      },
      {
        path: 'detail',
        name: 'detail',
        meta: { auth: false },
        component: () => import(/* webpackChunkName: "xjtech" */ './views/cms/CmsDetail')
      },
    ]
  },
  {
    path: '/',
    component: FullScreenLayout,
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        meta: { auth: false },
        component: () => import(/* webpackChunkName: "xjtech" */ './views/Login')
      },
      {
        path: 'register',
        name: 'register',
        meta: { auth: false },
        component: () => import(/* webpackChunkName: "xjtech" */ './views/Register')
      }
    ]
  }
]
export default RouterMap
